import EntitlementSidePanel from './EntitlementSidePanel';
export default EntitlementSidePanel;
